import { cjk } from "@streamdown/cjk";
import { code } from "@streamdown/code";
import { math } from "@streamdown/math";
import { mermaid } from "@streamdown/mermaid";
import { Streamdown } from "streamdown";
import "katex/dist/katex.min.css";

function payLinkRegex(): RegExp {
  return /(\/pay\/[^\s)\]`'"<>]+)|(https?:\/\/[^\s)\]`'"<>]*\/pay\/[^\s)\]`'"<>]+)/gi;
}

function normalizePayHref(match: string, payFrontendOrigin: string): string {
  const origin = payFrontendOrigin.replace(/\/$/, "");
  if (match.startsWith("http://") || match.startsWith("https://")) {
    return match;
  }
  return `${origin}${match.startsWith("/") ? match : `/${match}`}`;
}

function toMarkdownWithPayLinks(text: string, payFrontendOrigin: string): string {
  if (!payFrontendOrigin.trim()) {
    return text;
  }
  return text.replace(payLinkRegex(), (raw) => {
    const href = normalizePayHref(raw, payFrontendOrigin);
    return `[${raw}](${href})`;
  });
}

/**
 * Renders assistant markdown text with /pay links normalized to the main app origin.
 */
export function AssistantText({
  text,
  payFrontendOrigin,
  isStreaming = false,
}: {
  text: string;
  payFrontendOrigin: string;
  isStreaming?: boolean;
}) {
  const markdown = toMarkdownWithPayLinks(text, payFrontendOrigin);
  return (
    <div className="streamdown-message text-sm leading-relaxed text-neutral-900 dark:text-neutral-50">
      <Streamdown
        plugins={{ code, mermaid, math, cjk }}
        isAnimating={isStreaming}
        components={{
          a: ({ href = "", children, ...props }) => (
            <a
              {...props}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-neutral-900 underline underline-offset-2 dark:text-neutral-100"
            >
              {children}
            </a>
          ),
        }}
      >
        {markdown}
      </Streamdown>
    </div>
  );
}
